import { Box, Button } from "@mui/material";
import QRCodeStyling from "qr-code-styling";
import { useEffect, useRef, useState } from "react";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Paypoint;

type Props = {
  paypointPublicID: string;
  size?: number;
  downloadFileName?: string;
  isDownloadEnabled?: boolean;
};

export const PaypointQRCode = ({
  size,
  paypointPublicID,
  downloadFileName,
  isDownloadEnabled,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const [qrCode] = useState<QRCodeStyling>(
    new QRCodeStyling({
      width: size ?? 250,
      height: size ?? 250,
      data: `${appUrl("latest-pay-point-transaction")}/${paypointPublicID}`,
      margin: 0,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: false,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: { type: "rounded", color: "#000000", gradient: undefined },
      backgroundOptions: { color: "#ffffff" },
      image: "/qr-logo.svg",
      cornersSquareOptions: { type: "extra-rounded", color: "#000000" },
      cornersDotOptions: { type: "dot", color: "#000000" },
      type: "svg",
    }),
  );

  const { t } = useResource();

  useEffect(() => {
    qrCode.append(ref.current ?? undefined);
  }, [qrCode]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <div ref={ref} />
      {isDownloadEnabled && (
        <Button
          variant="text"
          color="primary"
          onClick={() =>
            qrCode.download({ extension: "png", name: downloadFileName })
          }
        >
          {t(RESOURCES.DownloadQRCode)}
        </Button>
      )}
    </Box>
  );
};
